import { toAnalyticsEvent } from './analytics_event';

export function forwardStoryEvents(sendEvent) {
  ['sw.story.start', 'sw.story.end'].forEach(eventName => {
    document.addEventListener(eventName, event => {
      sendEvent(toAnalyticsEvent(event));
    });
  });
}
